export const API_BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL;
export const ENDPOINTS = {
  AUTH: {
    LOGIN: "/authservice/auth/login",
    SENDOTP: "/authservice/auth/send/otp",
    VERIFYOTP: "/authservice/auth/verify/otp",
    UPDATEPASS: "/authservice/auth/update/password",
    FETCHLOGINDETAILSFROMTOKEN: "/authservice/auth/fetch/user/details",
    FETCHUSERNOTIFICATIONTOKEN: "/authservice/auth/fetch/notificationtoken",
  },
  OVERVIEW: {
    GETCAROUSELDATA: "/appointmentservice/appointment/overview",
    APPOINTMENTANALYSIS: "/appointmentservice/appointment/analysis",
    ADMINCLINICPERFORMANCE: "/appointmentservice/appointment/overview/revenue",
    ADMINREVENUEGRAPH: "/appointmentservice/appointment/overview/revenuestats",
  },
  PATIENT: {
    ADD: "/authservice/auth/signup",
    SENDOTP: "/authservice/auth/send/otp",
    VERIFYOTP: "/authservice/auth/verify/otp",
    GETLIST: "/patientservice/patient/listing",
    UPDATE: "/patientservice/user/update/:patientId",
    DELETE: "/authservice/auth/delete/user",
    VERITYPATIENTBYMOBILE: "/patientservice/patient/fetch",
    GETVITALS: "/patientservice/patient/vitals/fetch",
    ADDVITALS: "/patientservice/patient/vitals/add",
    ADDHEALTHRECORD:
      "/patientservice/patient/add/patienthealthrecord/:patientId",
    GETHEALTHRECORD:
      "/patientservice/patient/fetch/patienthealthrecord/:patientId",
    DELETEHEALTHRECORD:
      "/patientservice/patient/delete/patienthealthrecord/:recordId",
    UPDATEHEALTHRECORD:
      "/patientservice/patient/update/patienthealthrecord/:recordId",
    DELETEPROFILEIMAGE: "/patientservice/user/delete/profileImage/:patientId",
    GETAVAILABILITY: "/appointmentservice/patient/availability/:patientId",
    GETPATIENTDETAILS: "/patientservice/patient/fetch/details",
    ADDFAMILYMEMBER: "/patientservice/patient/add/familymember",
    GETBYNUMBER: "/orderservice/offline/get/patient",
  },
  DOCTOR: {
    ADD: "/authservice/auth/signup",
    GETLIST: "/doctorservice/doctor/admin/listing",
    UPDATE: "/doctorservice/doctor/update/:doctorId",
    GETDOCTORBYID: "/doctorservice/doctor/details",
    DELETE: "/authservice/auth/delete/user",
    SPECIALIZATIONDROPDOWN: "/doctorservice/specialization/fetch/all",
    APPOINTMENTDATA: "/doctorservice/doctor/fetch/appointmentDetails",
    PATIENTHISTORY: "/doctorservice/doctor/fetch/appointment/date",
    DELETEPROFILEIMAGE: "/doctorservice/doctor/delete/profileImage/:doctorId",
    MAPDETAILS: "/doctorservice/user/map-details",
    DECOMMISSION: "/doctorservice/user/decommission",
    // NEW DOCTOR TIME FRAME APIS
    GETNEWDOCTORPREFERENCES: "/appointmentservice/slots/doctor-preference",
    ADDNEWDOCTORPREFERENCES: "/appointmentservice/slots/create",
    UPDATENEWDOCTORPREFERENCES: "/appointmentservice/slots/update-time-frame",
    DELETETIMEFRAME: "/appointmentservice/slots/delete-time-frame",
    ADDNEWAPPOINTMENTSETTING: "/appointmentservice/slots/create",
    FETCHCLINICLISTING: "/dandarhealthclinicservice/clinic/listing",
    GET_ADMIN_DOCTOR_DETAILS: "/doctorservice/doctor/admin/details/:doctorId",
    UPDATEAPPOINTMENTSETTING:
      "/appointmentservice/slots/update-appointment-setting",
    UPDATETIMEFRAME: "/appointmentservice/slots/update-time-frame",
    CLINIC_DOCTOR_LISTING: "/doctorservice/doctor/clinic/doctor-listing",
    PRESCRIPTION_DATA: "/appointmentservice/doctor/prescription-data",
    PRESCRIPTION_DATA_BY_ID: "/appointmentservice/doctor/prescription-data/:doctorId",
  },
  CLINIC: {
    ADD: "/authservice/auth/signup",
    UPDATE: "/dandarhealthclinicservice/clinic/update/:clinicId",
    DELETE: "/authservice/auth/delete/user",
    GETLIST: "/dandarhealthclinicservice/clinic/listing",
    CLINICDROPDOWN: "/dandarhealthclinicservice/clinic/supervisor/dropdown",
    DELETEPROFILEIMAGE:
      "/dandarhealthclinicservice/clinic/delete/profileImage/:clinicId",
  },
  SUPERVISIOR: {
    ADD: "/authservice/auth/signup",
    GETLIST: "/dandarhealthclinicservice/clinic/supervisor/listing",
    UPDATE:
      "/dandarhealthclinicservice/clinic/supervisor/update/:supervisiorId",
    DELETE: "/authservice/auth/delete/user",
  },
  APPOINTMENT: {
    CREATE: "/appointmentservice/appointment/create",
    CANCLE: "/appointmentservice/appointment/cancel/:appointmentId",
    UPDATEAPPOINTMENTDATA:
      "/appointmentservice/appointment/update/appointmentdetails/:appointmentId",
    RESCHEDULE: "/appointmentservice/appointment/reschedule",
    FINDDOCTORSLOT: "/appointmentservice/appointment/doctoravailableslots",
    FINDAPPOINTMENTLISTING: "/appointmentservice/appointment/listing",
    UPDATEAPPOINTMENTSTATUS:
      "/appointmentservice/appointment/updateappointmentstatus",
    GETVIDEOTOKEN: "/authservice/videosdk/fetch/token",
    GETPATIENTAPPOINTMENTHISTORY:
      "/appointmentservice/appointment/fetch/patienthistory",
    GETAPPOINTMENTCOUNTEPERDAY:
      "/appointmentservice/appointment/fetch/appointmentscount/:id",
    GETAPPOINTMENTOVERVIEW:
      "/appointmentservice/appointment/fetch/appointmentlisting/overview",
    GET_APPOINTMENT_LISTING_V2: "/appointmentservice/appointment/get/appointment-listing",
    GET_SUMMARY: "/appointmentservice/appointment/fetch/appointmentsummary/:appointmentId",
    GETALLMEDICINES: "/product/listing/medicines",
    GETDOCTORBYDATE: "/appointmentservice/slots/available-doctors-by-date",
    AVAILABLE_DOCTORS: "/appointmentservice/slots/available-doctors",
    DAILY_SLOTS: "/appointmentservice/slots/daily-slots",
    NEXT_AVAILABLE_DATES: "/appointmentservice/slots/next-available-dates",
    MARK_COMPLETED: "/appointmentservice/appointment/mark-completed/:appointmentId",
    MARK_IN_CONSULTATION: "/appointmentservice/appointment/mark-in-consultation/:appointmentId",
    UPDATE_PENDING_PAYMENT: "/appointmentservice/appointment/update/pending-payment",
    UPDATE_PAYMENT_METHOD: "/appointmentservice/appointment/update/payment-method",
    PRESCRIPTION_SKELETON: "/appointmentservice/appointment/prescription/skeleton-details/:appointmentId",
    DOCTOR_APPOINTMENT_SETTINGS: "/appointmentservice/slots/doctor-unique-clinics",
    UPLOAD_PRESCRIPTION: "/appointmentservice/appointment/upload/prescription/:appointmentId",
  },
  PATIENT_V2: {
    ADD_VITALS: "/patientservice/patient/medication/vitals/add",
    UPDATE_VITALS: "/patientservice/patient/medication/vitals/update",
    ADD_PRESCRIPTION: "/patientservice/patient/medication/prescriptions/add",
    DELETE_PRESCRIPTION: "/patientservice/patient/medication/prescriptions/delete/:id",
  },
  ANALYTICS: {
    SEARCH_ANALYTICS: "/patientservice/global/search-analytics",
    SEARCH_ANALYTICS_DASHBOARD: "/patientservice/global/search-analytics/dashboard",
    REVIEW_ANALYTICS: "/patientservice/blogs/reviews",
    REVIEW_ANALYTICS_DASHBOARD: "/patientservice/blogs/reviews/dashboard",
  },
  MEDICALCAMP: {
    CREATE: "/authservice/auth/signup",
    GETLIST: "/dandarhealthclinicservice/medicalcamp/listing",
    UPDATE: "/dandarhealthclinicservice/medicalcamp/update",
    DELETE: "/authservice/auth/delete/user",
  },
  VIDEOSDK: {
    GETTOKEN: "/authservice/videosdk/fetch/token",
  },
  NOTIFICATION: {
    SEND_NOTIFICATION: "/dandarnotificationservice/notifications/send",
    CREATENOTIFICATION: "/dandarnotificationservice/notifications/create",
  },
  INVENTORY: {
    GETPRODUCTLISTING: "/inventoryorderservice/product/v2/listing",
    GETPRODUCTDETAILSINWARD: "/inventoryorderservice/product/details/:productId",
    GETPRODUCTDETAILS: "/inventoryorderservice/product/v2/details/:productId",
    CREATENEWPRODUCT: "/inventoryorderservice/product/v2/create",
    UPDATEPRODUCT: "/inventoryorderservice/product/v2/update/basic-details/:productId",
    UPDATEPRODUCT_ACTIVITY: "/inventoryorderservice/product/v2/active/:productId",
    UPDATEPRODUCT_PKGN: "/inventoryorderservice/product/v2/update/pkgn/:productId",
    UPDATEPRODUCT_INFO: "/inventoryorderservice/product/v2/update/info/:productId",
    UPDATEPRODUCT_TAXES: "/inventoryorderservice/product/v2/update/taxes/:productId",
    UPDATEPRODUCT_CATEGORIES: "/inventoryorderservice/product/v2/update/listing-categories/:productId",
    UPDATEVARIENTS:
      "/inventoryorderservice/product/update/productvarient/:varientId",
    DELETEVARIENTS:
      "/inventoryorderservice/product/delete/productvarient/:varientId",
    DELETEPRODUCT: "/inventoryorderservice/product/delete/:productId",
    CREATENEWLABTEST: "/inventoryorderservice/labtest/create",
    GETLABTESTLISTING: "/inventoryorderservice/labtest/listing",
    GETLABTESTDETAILS: "/inventoryorderservice/labtest/fetch/id/:labtest",
    UPDATELABTEST: "/inventoryorderservice/labtest/update/:labTestId",
    DELETELABTEST: "/inventoryorderservice/labtest/delete/:labTestId",
    ADDVARIANT: "/inventoryorderservice/product/add/variant",
    GETLABTESTCATEGORY:
      "/inventoryorderservice/labtest/fetch/labtest/categories",
    ADDNEWSALT: "/inventoryorderservice/product/add-salts",
    UPDATESALT: "/inventoryorderservice/product/update-salt/:saltId",
    DELETESALT: "/inventoryorderservice/product/delete-salt/:saltId",
    DASHBOARDOVERVIEW: "/inventoryorderservice/order/overview",
    GETCLINICSTOCK: "/inventoryorderservice/stock/get/clinic-stock",
    GETCATEGORYLIST: "/inventoryorderservice/product/listing-categories",
    ADDCATEGORY: "/inventoryorderservice/product/add-listing-category",
    DELETECATEGORY: "/inventoryorderservice/product/remove-listing-category",
    GETALLCATEGORIES: "/inventoryorderservice/product/all-categories",
    CREATESTOCKREQUEST: "/inventoryorderservice/stock/create-request-inventory",
    GETSTOCKREQUESTLISTING:
      "/inventoryorderservice/stock/get-request-inventory",
    DELETESTOCKREQUEST:
      "/inventoryorderservice/stock/delete-request-inventory/:id",
  },
  MEDICINE: {
    GETMEDICINELISTING: "/inventoryorderservice/medicine/listing",
    CREATENEWMEDICINE: "/inventoryorderservice/medicine/create",
    UPDATEMEDICINE: "/inventoryorderservice/medicine/update/:id",
    DELETEMEDICINE: "/inventoryorderservice/medicine/delete/:id",
    GETALLMEDICINES: "/inventoryorderservice/product/listing/medicines",
  },
  ORDERS: {
    GETORDERLISTING: "/orderservice/online-order/get-order-listing",
    CREATEORDER: "/inventoryorderservice/order/create",
    UPDATEORDERBYCLINIC: "/orderservice/online-order/update-order-by-clinic",
    UPDATEORDERSTATUS: "/inventoryorderservice/order/update",
    GETORDERDETAILS: "/inventoryorderservice/order/details/:id",
    GETCLINICSNAME:
      "/dandarhealthclinicservice/clinic/fetch/clinicListingForOrders",
    GETPATIENTDETAILS: "/patientservice/patient/detailsById",
    UPDATEORDER: "/inventoryorderservice/order/update/admin/:orderId",
    ADDORDERITEMBYADMIN:
      "/inventoryorderservice/order/update/items/admin/:orderId",
    GENERATEBILL: "/orderservice",
    CANCEL_ORDER: "/inventoryorderservice/order/update/status/:orderId",
    ASSIGN_DRIVER: "/inventoryorderservice/order/assign/driver",
    CHECKORDER: "/inventoryorderservice/order/check-order",
    CHECKPRODUCT: "/inventoryorderservice/order/check-product",
    NOTIFYPATIENT: "/orderservice/online-order/update-order-by-admin",
    REASSIGNEDRIVER: "/orderservice/online-order/reassign-driver",
  },
  WHOLESALERS: {
    GETWHOLESALEROPTIONS: "/inventoryorderservice/wholesaler/options",
    ADDNEWWHOLESALER: "/inventoryorderservice/wholesaler/create",
    GETWHOLESALERLIST: "/inventoryorderservice/wholesaler/list",
    GETWHOLESALERDETAILS: "/inventoryorderservice/wholesaler/details/:id",
    UPDATEWHOLESALERDETAILS: "/inventoryorderservice/wholesaler/update/:id",
    DELETEWHOLESALER: "/inventoryorderservice/wholesaler/delete/:id",
    CHECKEXISTINGDLNUMBER: "/inventoryorderservice/wholesaler/check/dlnumber",
  },
  MANUFACTURER: {
    GETMANUFACTUREROPTIONS: "/inventoryorderservice/manufacturer/options",
    ADDNEWMANUFACTURER: "/inventoryorderservice/manufacturer/create",
    GETMANUFACTURERLIST: "/inventoryorderservice/manufacturer/get-all",
    GETMANUFACTURERDETAILS: "/inventoryorderservice/manufacturer/get-by-id/:id",
    UPDATEMANUFACTURERDETAILS:
      "/inventoryorderservice/manufacturer/update/:manufacturerId",
    DELETEMANUFACTURER: "/inventoryorderservice/manufacturer/delete/:id",
  },
  MARKETER: {
    GETMARKETEROPTIONS: "/inventoryorderservice/manufacturer/marketer/options",
    ADDNEWMARKETER: "/inventoryorderservice/manufacturer/marketer/create",
    GETMARKETERLIST: "/inventoryorderservice/manufacturer/marketer/get-all",
    GETMARKETERDETAILS:
      "/inventoryorderservice/manufacturer/marketer/get-by-id/:id",
    UPDATEMARKETERDETAILS:
      "/inventoryorderservice/manufacturer/marketer/update/:marketerId",
    DELETEMARKETER: "/inventoryorderservice/manufacturer/marketer/delete/:id",
  },
  STOCKS: {
    ADDTOSTOCK: "/inventoryorderservice/stock/create",
    GETDISTINCTINWARDSTOCKS:
      "/inventoryorderservice/stock/distinct-inward-stock",
    GETINWARDPRODUCTDETAILS:
      "/inventoryorderservice/stock/get-inward-product-details-by-id/:id",
    UPDATESELLINGPRICE: "/inventoryorderservice/stock/create-selling-price",
    GETALLINVENTRYLIST: "/inventoryorderservice/stock/get-inventory-list",
    GETINWARDSTOCKFORCLINIC:
      "/inventoryorderservice/stock/fetch/clinic/:clinicId",
    GETEXPIRYALERTS: "/inventoryorderservice/stock/expiry-details",
    GETINVOICEHISTORY: "/inventoryorderservice/stock/invoice-history",
    GETINVOICEHISTORYDETAILS:
      "/inventoryorderservice/stock/invoice-history-details",
    CHECKINVOICENUMBERAVAILABILITY:
      "/inventoryorderservice/stock/checking-invoice-number",
    CHECKBATCHNUMBERAVAILABILITY:
      "/inventoryorderservice/stock/checking-invoice-number",
    UPDATELABTESTSTATUSBYCLINIC:
      "/inventoryorderservice/order/update/status/:orderId",
    UPDATEPAYMENTSTATUS: "/inventoryorderservice/stock/update-payment-status",
  },
  // V3 product catalogue: id-based classification, normalised composition and
  // split attribute tables. See ProductControllerV3 in the inventory service.
  PRODUCT_V3: {
    CREATE: "/inventoryorderservice/product/v3/create",
    UPDATE: "/inventoryorderservice/product/v3/update/:productId",
    DETAILS: "/inventoryorderservice/product/v3/details/:productId",
    LISTING: "/inventoryorderservice/product/v3/listing",
    ADMIN_LISTING: "/inventoryorderservice/product/v3/admin-listing",
    SET_ACTIVE: "/inventoryorderservice/product/v3/active/:productId",
    SET_STATUS: "/inventoryorderservice/product/v3/status/:productId",
    REPLACE_COMPOSITION: "/inventoryorderservice/product/v3/composition/:productId",
    REPLACE_CATEGORY_MAPPINGS:
      "/inventoryorderservice/product/v3/category-mappings/:productId",
    SUBSTITUTES: "/inventoryorderservice/product/v3/substitutes/:productId",
    VERIFICATION_HISTORY:
      "/inventoryorderservice/product/v3/verification-history/:productId",
    ENRICH: "/inventoryorderservice/product/v3/enrich",
  },
  // Classification masters (primary category / subcategory / group), their
  // three-level mapping, and the domain + regulatory domain rules.
  PRODUCT_CATEGORY: {
    PRIMARY_CATEGORY_CREATE: "/inventoryorderservice/product-category/primary-category",
    PRIMARY_CATEGORY_LIST: "/inventoryorderservice/product-category/primary-category",
    PRIMARY_CATEGORY_OPTIONS:
      "/inventoryorderservice/product-category/primary-category/options",
    PRIMARY_CATEGORY_UPDATE:
      "/inventoryorderservice/product-category/primary-category/:id",

    SUBCATEGORY_CREATE: "/inventoryorderservice/product-category/subcategory",
    SUBCATEGORY_LIST: "/inventoryorderservice/product-category/subcategory",
    SUBCATEGORY_OPTIONS: "/inventoryorderservice/product-category/subcategory/options",
    SUBCATEGORY_UPDATE: "/inventoryorderservice/product-category/subcategory/:id",

    GROUP_CREATE: "/inventoryorderservice/product-category/group",
    GROUP_LIST: "/inventoryorderservice/product-category/group",
    GROUP_OPTIONS: "/inventoryorderservice/product-category/group/options",
    GROUP_UPDATE: "/inventoryorderservice/product-category/group/:id",

    DOMAIN_CREATE: "/inventoryorderservice/product-category/domain",
    DOMAIN_LIST: "/inventoryorderservice/product-category/domain",
    DOMAIN_OPTIONS: "/inventoryorderservice/product-category/domain/options",
    DOMAIN_UPDATE: "/inventoryorderservice/product-category/domain/:id",

    REGULATORY_DOMAIN_CREATE: "/inventoryorderservice/product-category/regulatory-domain",
    REGULATORY_DOMAIN_LIST: "/inventoryorderservice/product-category/regulatory-domain",
    REGULATORY_DOMAIN_OPTIONS:
      "/inventoryorderservice/product-category/regulatory-domain/options",
    REGULATORY_DOMAIN_UPDATE:
      "/inventoryorderservice/product-category/regulatory-domain/:id",

    HIERARCHY_CREATE: "/inventoryorderservice/product-category/hierarchy",
    HIERARCHY_LIST: "/inventoryorderservice/product-category/hierarchy/list",
    HIERARCHY_OPTIONS: "/inventoryorderservice/product-category/hierarchy/options",
    HIERARCHY_SUBCATEGORIES:
      "/inventoryorderservice/product-category/hierarchy/subcategories",
    HIERARCHY_GROUPS: "/inventoryorderservice/product-category/hierarchy/groups",
    HIERARCHY_SET_ACTIVE: "/inventoryorderservice/product-category/hierarchy/:id/active",

    DOMAIN_RULE_PRIMARY_UPSERT:
      "/inventoryorderservice/product-category/domain-rule/primary-category",
    DOMAIN_RULE_PRIMARY_LIST:
      "/inventoryorderservice/product-category/domain-rule/primary-category/list",
    DOMAIN_RULE_PRIMARY_DELETE:
      "/inventoryorderservice/product-category/domain-rule/primary-category/:id",
    DOMAIN_RULE_SUBCATEGORY_UPSERT:
      "/inventoryorderservice/product-category/domain-rule/subcategory",
    DOMAIN_RULE_SUBCATEGORY_LIST:
      "/inventoryorderservice/product-category/domain-rule/subcategory/list",
    DOMAIN_RULE_SUBCATEGORY_DELETE:
      "/inventoryorderservice/product-category/domain-rule/subcategory/:id",
    DOMAIN_RULE_RESOLVE: "/inventoryorderservice/product-category/domain-rule/resolve",
  },
  // Salt / drug masters, their mapping, and the medicine schedules.
  MEDICINE_SALT: {
    SALT_CREATE: "/inventoryorderservice/medicine-salt/salt/create",
    SALT_UPDATE: "/inventoryorderservice/medicine-salt/salt/update/:id",
    SALT_LIST: "/inventoryorderservice/medicine-salt/salt/list",
    SALT_OPTIONS: "/inventoryorderservice/medicine-salt/salt/options",

    DRUG_CREATE: "/inventoryorderservice/medicine-salt/drug/create",
    DRUG_UPDATE: "/inventoryorderservice/medicine-salt/drug/update/:id",
    DRUG_LIST: "/inventoryorderservice/medicine-salt/drug/list",
    DRUG_OPTIONS: "/inventoryorderservice/medicine-salt/drug/options",

    SCHEDULE_CREATE: "/inventoryorderservice/medicine-salt/schedule/create",
    SCHEDULE_UPDATE: "/inventoryorderservice/medicine-salt/schedule/update/:id",
    SCHEDULE_LIST: "/inventoryorderservice/medicine-salt/schedule/list",
    SCHEDULE_OPTIONS: "/inventoryorderservice/medicine-salt/schedule/options",

    MAPPING_CREATE: "/inventoryorderservice/medicine-salt/mapping/create",
    MAPPING_LIST: "/inventoryorderservice/medicine-salt/mapping/list",
    MAPPING_OPTIONS: "/inventoryorderservice/medicine-salt/mapping/options",
  },
  // Product form groups and the forms inside them (Tablet, Syrup, Cream, ...).
  PRODUCT_FORM: {
    GROUP_CREATE: "/inventoryorderservice/product-form/group/create",
    GROUP_UPDATE: "/inventoryorderservice/product-form/group/update/:id",
    GROUP_LIST: "/inventoryorderservice/product-form/group/list",
    GROUP_OPTIONS: "/inventoryorderservice/product-form/group/options",
    GROUP_DETAILS: "/inventoryorderservice/product-form/group/details/:id",

    FORM_CREATE: "/inventoryorderservice/product-form/create",
    FORM_UPDATE: "/inventoryorderservice/product-form/update/:id",
    FORM_LIST: "/inventoryorderservice/product-form/list",
    FORM_OPTIONS: "/inventoryorderservice/product-form/options",
    FORM_DETAILS: "/inventoryorderservice/product-form/details/:id",
  },
  INVOICECHARGESHEAD: {
    CREATE: "/inventoryorderservice/invoice-charges-head/create",
    LIST: "/inventoryorderservice/invoice-charges-head/list",
    UPDATE: "/inventoryorderservice/invoice-charges-head/update/:id",
  },
  DRIVER: {
    GETDRIVERLISTING: "/deliveryservice/driver/listing",
    CREATEDRIVER: "/authservice/auth/driver/registration",
    GETDRIVERDETAILS: "/deliveryservice/driver/details",
    UPDATEDRIVER: "/deliveryservice/driver/update",
    DELETEDRIVER: "/deliveryservice/driver/delete/:id",
    GETAVAILABLEDRIVER: "/deliveryservice/driver/available-drivers",
  },
  LAB: {
    GETLABCATEGORIES: "/inventoryorderservice/labtest/fetch/labtest/categories",
    GETLABTYPES: "/inventoryorderservice/labtest/fetch/types",
    GETLABTESTOPTIONS: "/inventoryorderservice/labtest/listing/simple",
    UPDATELABORDER: "/inventoryorderservice/order/add/lab-report",
    GETLABTESTLISTING: "/orderservice/labtest/listing",
    GETLABTESTDETAILS: "/orderservice/labtest/order-details/:orderId",
    UPLOADDOCUMENTS: "/orderservice/labtest/upload-report/:orderId",
    UPDATESTATUS: "/orderservice/online-order/update-order-status",
    ADDLABTEST: "/inventoryorderservice/labtest/create",
    LABTESTLISTING: "/inventoryorderservice/labtest/listing",
    ADDTESTS: "/orderservice/labtest/add-tests",
    ASSIGNDRIVER: "/orderservice/labtest/assign-pickup",
    FORWARDTOLAB: "/orderservice/labtest/forward-to-lab",
    GETLABTESTDETAILSBYID: "/inventoryorderservice/labtest/fetch/id/:id",
    UPDATELABTEST: "/inventoryorderservice/labtest/update/:id",
  },
  RETURN: {
    RETURN_ITEM_LISTING:
      "/orderservice/online-order/fetch-return-order-listing",
    UPDATE_RETURN_STATUS:
      "/orderservice/online-order/update-return-order-status",
    UPDATE_INVENTORY: "/orderservice/online-order/update-return-stock",
  },
  OFFLINE_ORDER: {
    CREATE_NEW_ORDER: "/orderservice/offline/create/offline-order",
    GET_CLINIC_DETAILS_BY_ID: "/dandarhealthclinicservice/clinic/fetch/clinics",
    GET_OFFLINE_ORDERS: "/orderservice/offline/offline-orders/listing-v2",
    GET_OFFLINE_ORDER_DETAILS_BY_ORDER_ID:
      "/orderservice/offline/offline-order/details",
    CHECK_RETURN_ITEM_STATUS: "/orderservice/offline/check/item-returnable",
    RETURN_OFFLINE_ORDER: "/orderservice/offline/create/offline-return",
    GET_CLINIC_GSTN_BY_PINCODE: "/orderservice/offline/get/gstIn",
    UPDATE_OFFLINE_ORDER: "/orderservice/offline/update/offline-order",
  },
  BLOG: {
    ADD_NEW_BLOG: "/patientservice/blogs/create",
    UPDATE_BLOG: "/patientservice/blogs/update-blog/:id",
    DELETE_BLOG: "/patientservice/blogs/delete-blog/:id",
    GET_BLOG_DETAILS: "/patientservice/blogs/details/:id",
    GET_ALL_BLOG: "/patientservice/blogs/get-all",
    ADD_NEW_BLOG_CONTENT: "/patientservice/blogs/contents/:id",
    DELETE_BLOG_CONTENT: "/patientservice/blogs/contents/:contentId",
    UPDATE_BLOG_CONTENT: "/patientservice/blogs/contents/:contentId",
    FETCH_VIDEOS: "/patientservice/blogs/videos",
    DELETE_VIDEOS: "/patientservice/blogs/video/:id",
    ADD_VIDEO: "/patientservice/blogs/video",
  },
  REPORT: {
    GET_OFFLINE_ORDER_REPORT: "/orderservice/report/offline-orders",
    GET_ONLINE_ORDER_REPORT: "/orderservice/report/online-orders",
    GET_LABTEST_ORDER_REPORT: "/orderservice/report/lab-test-orders",
    GET_ONLINE_DAYWISE_REPORT:
      "/orderservice/report/day-wise-online-order-revenue",
    GET_OFFLINE_DAYWISE_REPORT:
      "/orderservice/report/day-wise-offline-order-revenue",
    GET_ONLINE_REVENUE_SUMMARY:
      "/orderservice/report/online-revenue-summary",
    GET_OFFLINE_REVENUE_SUMMARY:
      "/orderservice/report/offline-revenue-summary",
    GET_STOCK_REPORT: "/inventoryorderservice/report/stock-report",
  },
  PRODUCT_ENQUIRY: {
    CREATE: "/inventoryorderservice/enquiry/create",
    LIST: "/inventoryorderservice/enquiry/list",
    DELETE: "/inventoryorderservice/enquiry/:id",
    ANALYTICS: "/inventoryorderservice/enquiry/analytics",
  },
  TRANSACTION_HISTORY: {
    PAYMENT_SUMMARY: "/dandarhealthclinicservice/clinic/payment-summary/",
    CLINICS_FINANCIAL_LISTING: "/dandarhealthclinicservice/clinic/payment-summary/clinics",
    PAYMENT_ORDERS: "/orderservice/report/payment-orders",
    APPOINTMENT_PAYMENT_DETAILS: "/appointmentservice/appointment/payment-summary/details",
    EXPENSE_LISTING: "/dandarhealthclinicservice/clinic/expense/listing",
    EXPENSE_CREATE: "/dandarhealthclinicservice/clinic/expense/create",
    EXPENSE_TYPE_LISTING: "/dandarhealthclinicservice/clinic/expense-type/listing",
    EXPENSE_TYPE_CREATE: "/dandarhealthclinicservice/clinic/expense-type/create",
    BANK_DEPOSIT_CREATE: "/dandarhealthclinicservice/clinic/bank-deposit/create",
    BANK_DEPOSIT_LISTING: "/dandarhealthclinicservice/clinic/bank-deposit/listing",
    MONTH_END_LOG_CREATE: "/dandarhealthclinicservice/clinic/month-end-log/create",
    MONTH_END_LOG_GET: "/dandarhealthclinicservice/clinic/month-end-log/get",
    MONTH_END_LOG_FETCH_BY_ID: "/dandarhealthclinicservice/clinic/month-end-log/fetch/:id",
    MONTH_END_LOG_LISTING: "/dandarhealthclinicservice/clinic/month-end-log/listing",
    MONTH_END_LOG_UPDATE: "/dandarhealthclinicservice/clinic/month-end-log/update",
  },
  STAFF: {
    SIGNUP: "/authservice/auth/signup",
    UPDATE: "/dandarhealthclinicservice/clinic/staff/update/:staffId",
    UPDATE_STATUS: "/dandarhealthclinicservice/clinic/staff/status",
    LISTING: "/dandarhealthclinicservice/clinic/staff/listing",
    DETAILS: "/dandarhealthclinicservice/clinic/staff/details/:staffId",
    OPTIONS: "/dandarhealthclinicservice/clinic/staff/options",
    DOCUMENT_UPLOAD: "/dandarhealthclinicservice/clinic/staff/document/upload/:staffId",
    DOCUMENT_DELETE: "/dandarhealthclinicservice/clinic/staff/document/:documentId",
    SALARY_REVISION: "/dandarhealthclinicservice/clinic/staff/salary-revision",
    SALARY_REVISIONS_HISTORY: "/dandarhealthclinicservice/clinic/staff/salary-revisions/:staffId",
  },
} as const;

export const getFullUrl = (endpoint: string) => `${API_BASE_URL}${endpoint}`;
